import Usuario from '@/spa/usuario/CadastroUsuario';
import UsuarioFornecedorDadosSensiveis from '../../../spa/usuario/UsuarioFornecedorDadosSensiveis';
import TermoAceiteUsuario from '../../../spa/termo-aceite/TermoAceiteUsuario';

const UsuarioFornecedorForm = () => import('@/spa/usuario/UsuarioFornecedorForm');
const UsuarioFornecedorList = () => import('@/spa/usuario/UsuarioFornecedorList');

export default {
  path: 'usuario-fornecedor',
  component: Usuario,
  children: [
    {
      path: '',
      name: 'usuario-fornecedor',
      component: UsuarioFornecedorList,
    },
    {
      path: ':id/editar',
      name: 'editarUsuarioFornecedor',
      component: UsuarioFornecedorForm,
      props: {
        somenteLeitura: false,
      },
    },
    {
      path: ':id/editar-dados-sensiveis',
      name: 'editarDadosSensiveisUsuarioFornecedor',
      component: UsuarioFornecedorDadosSensiveis,
      props: {
        somenteLeitura: false,
      },
    },
    {
      path: 'termo-uso/:idAceite',
      name: 'verAceiteTermoUso',
      component: TermoAceiteUsuario,
    },
    {
      path: 'termo-nomeacao/:idAceite',
      name: 'verAceiteTermoNomeacao',
      component: TermoAceiteUsuario,
    },
    {
      path: 'novo',
      name: 'novoUsuarioFornecedor',
      component: UsuarioFornecedorForm,
    },
    {
      path: ':id',
      name: 'verUsuarioFornecedor',
      component: UsuarioFornecedorForm,
      props: {
        somenteLeitura: true,
      },
    },
  ],
};
